const RedemptionStatus = {
  Success: "success",
  Voided: "voided",
};

export default RedemptionStatus;
